const resortNames = [
  "Hiru Villa",
  "Hiru Mudra",
  "Hiru Om",
  "Hiru Aadya"
];
const AboutAyurveda = () => {
  return <section
    id="about-ayurveda"
    className="relative isolate overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
  >
            {
    /* Mobile Layout - sm and below */
  }
            <div className="lg:hidden container relative mx-auto flex flex-col gap-8 px-3 sm:px-5">
                {
    /* Label */
  }
                <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-3 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-[#7a4f1d] shadow-sm backdrop-blur w-fit">
                    Über Ayurveda
                </span>

                {
    /* Heading */
  }
                <h2 className="font-serif text-2xl font-semibold leading-[1.2] tracking-[-0.03em] text-[#10261a] sm:text-3xl">
                    Authentische Ayurveda-Praxis für Harmonie von Körper und Geist.
                </h2>

                {
    /* Image */
  }
                <div className="relative overflow-hidden rounded-[24px] border border-white/70 bg-white shadow-lg">
                    <div className="relative h-[300px] sm:h-[400px]">
                        <img
    src="/images/Hiru/public_images/680A4135-Enhanced-NR-Edit-copy.webp"
    alt="Ayurveda-Bereich im Hiru Resort"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/70 via-[#07130d]/20 to-transparent" />
                    </div>
                </div>

                {
    /* Content */
  }
                <div className="space-y-4">
                    <div className="space-y-4 font-mulish text-[15px] leading-7 text-[#334155] sm:text-base">
                        <p>
                            Hiru bedeutet auf Singhalesisch „Sonne“. Umgeben von Kokospalmen und tropischer Vegetation liegt Hiru Resort nur anderthalb Stunden vom internationalen Flughafen Colombo entfernt – ein stilles Refugium, das wie ein verstecktes Paradies wirkt.
                        </p>
                        <p>
                            Die vier individuellen Resorts – Hiru Villa, Hiru Mudra, Hiru Om und Hiru Aadya – verbinden modernen Komfort mit traditioneller Ayurveda-Praxis und laden dazu ein, dem Alltag für eine Weile zu entfliehen.
                        </p>
                        <p>
                            Hiru, die Sonne, ist auch im Sanskrit als Surya bekannt. In Sri Lanka gilt sie als heilige Kraft der Ayurveda-Pflanzen, die eine besonders heilende Wirkung besitzen.
                        </p>
                        <p>
                            In der Tradition Sri Lankas ist Surya, die Sonne, die Quelle des Feuerelements (Pitta) im menschlichen Körper. Es ist nicht nur der Motor einer gesunden Körpertemperatur, sondern auch ein entscheidender Faktor für Verdauung, Stoffwechsel und die Energie des gesamten Organismus.
                        </p>
                        <p>
                            Jedes Resort hat seinen eigenen Charakter, wird aber von einem engagierten Team mit herzlicher, familiärer Aufmerksamkeit betreut. In jedem Resort erhalten Gäste die gleiche hochwertige medizinische Betreuung durch erfahrene Ärzte. Die Therapien, Behandlungsansätze und Preise sind über alle Hiru Ayurveda Resorts hinweg konsistent, sodass Sie während Ihres Aufenthalts zwischen den Resorts wechseln und unterschiedliche Landschaften erleben können – je nach Aufenthaltsdauer.
                        </p>
                        <p>
                            Ein Aufenthalt in Hiru ist mehr als eine gewöhnliche Reise: Er ist eine Zeit der Wiederherstellung von Körper, Geist und Seele in ihren natürlichen Zustand. Aus Erfahrung zeigen sich die besten Ergebnisse meist nach 3 bis 4 Wochen. Deshalb empfehlen Ärzte in der Regel eine Mindestaufenthaltsdauer von 14 Tagen, damit alle Behandlungen vollständig und wirksam wirken können. Im Laufe der Zeit entsteht eine ruhige innere Klarheit, die man wirklich spüren kann.
                        </p>
                    </div>

                    <div className="rounded-2xl border border-amber-200/70 bg-white/75 p-5 shadow-lg backdrop-blur-sm">
                        <h3 className="font-serif text-lg font-semibold text-[#10261a] sm:text-xl">
                            Unterstützung, die über Sprachbarrieren hinweg tröstet
                        </h3>
                        <p className="mt-2 font-mulish text-[15px] leading-7 text-[#475569] sm:text-base">
                            Damit Sie sich ganz auf Ihre Behandlung konzentrieren können, stehen Ihnen auf dem Resort Guest Advisors in Japanisch, Englisch, Deutsch und Italienisch zur Seite – auch bei Arztgesprächen und bei allen Fragen während Ihres Aufenthalts.
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-2 sm:gap-3">
                        {resortNames.map((name) => <span
    key={name}
    className="rounded-full border border-emerald-200 bg-white/90 px-3 py-1.5 font-mulish text-xs sm:text-sm font-medium text-[#24422f] shadow-sm"
  >
                                {name}
                            </span>)}
                    </div>
                </div>
            </div>

            {
    /* Desktop Layout - lg and above */
  }
            <div className="hidden lg:grid container relative mx-auto gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-14 lg:px-8">
                <div>
                    <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-4 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-[#7a4f1d] shadow-sm backdrop-blur md:text-sm">
                        Über Ayurveda
                    </span>

                    <h2 className="mt-5 max-w-2xl font-serif text-3xl font-semibold leading-[1.2] tracking-[-0.03em] text-[#10261a] sm:text-4xl lg:text-5xl">
                        Authentische Ayurveda-Praxis für Harmonie von Körper und Geist.
                    </h2>

                    <div className="mt-6 space-y-5 font-mulish text-base leading-8 text-[#334155] sm:text-lg">
                        <p>
                            Hiru bedeutet auf Singhalesisch „Sonne“. Umgeben von Kokospalmen und tropischer Vegetation liegt Hiru Resort nur anderthalb Stunden vom internationalen Flughafen Colombo entfernt – ein stilles Refugium, das wie ein verstecktes Paradies wirkt.
                        </p>
                        <p>
                            Die vier individuellen Resorts – Hiru Villa, Hiru Mudra, Hiru Om und Hiru Aadya – verbinden modernen Komfort mit traditioneller Ayurveda-Praxis und laden dazu ein, dem Alltag für eine Weile zu entfliehen.
                        </p>
                        <p>
                            Hiru, die Sonne, ist auch im Sanskrit als Surya bekannt. In Sri Lanka gilt sie als heilige Kraft der Ayurveda-Pflanzen, die eine besonders heilende Wirkung besitzen.
                        </p>
                        <p>
                            In der Tradition Sri Lankas ist Surya, die Sonne, die Quelle des Feuerelements (Pitta) im menschlichen Körper. Es ist nicht nur der Motor einer gesunden Körpertemperatur, sondern auch ein entscheidender Faktor für Verdauung, Stoffwechsel und die Energie des gesamten Organismus.
                        </p>
                        <p>
                            Jedes Resort hat seinen eigenen Charakter, wird aber von einem engagierten Team mit herzlicher, familiärer Aufmerksamkeit betreut. In jedem Resort erhalten Gäste die gleiche hochwertige medizinische Betreuung durch erfahrene Ärzte. Die Therapien, Behandlungsansätze und Preise sind über alle Hiru Ayurveda Resorts hinweg konsistent, sodass Sie während Ihres Aufenthalts zwischen den Resorts wechseln und unterschiedliche Landschaften erleben können – je nach Aufenthaltsdauer.
                        </p>
                        <p>
                            Ein Aufenthalt in Hiru ist mehr als eine gewöhnliche Reise: Er ist eine Zeit der Wiederherstellung von Körper, Geist und Seele in ihren natürlichen Zustand. Aus Erfahrung zeigen sich die besten Ergebnisse meist nach 3 bis 4 Wochen. Deshalb empfehlen Ärzte in der Regel eine Mindestaufenthaltsdauer von 14 Tagen, damit alle Behandlungen vollständig und wirksam wirken können. Im Laufe der Zeit entsteht eine ruhige innere Klarheit, die man wirklich spüren kann.
                        </p>
                    </div>

                    <div className="mt-8 rounded-[28px] border border-amber-200/70 bg-white/75 p-6 shadow-[0_18px_50px_rgba(120,92,47,0.08)] backdrop-blur-sm sm:p-7">
                        <h3 className="font-serif text-2xl font-semibold text-[#10261a] sm:text-[1.75rem]">
                            Unterstützung, die über Sprachbarrieren hinweg tröstet
                        </h3>
                        <p className="mt-3 font-mulish text-base leading-8 text-[#475569] sm:text-lg">
                            Damit Sie sich ganz auf Ihre Behandlung konzentrieren können, stehen Ihnen auf dem Resort Guest Advisors in Japanisch, Englisch, Deutsch und Italienisch zur Seite – auch bei Arztgesprächen und bei allen Fragen während Ihres Aufenthalts.
                        </p>
                    </div>

                    <div className="mt-8 flex flex-wrap gap-3">
                        {resortNames.map((name) => <span
    key={name}
    className="rounded-full border border-emerald-200 bg-white/90 px-4 py-2 font-mulish text-sm font-medium text-[#24422f] shadow-sm"
  >
                                {name}
                            </span>)}
                    </div>
                </div>

                <div className="relative">
                    <div className="absolute -left-6 top-8 hidden h-28 w-28 rounded-full border border-white/70 lg:block" />
                    <div className="absolute -right-4 bottom-10 hidden h-20 w-20 rounded-full border border-white/70 lg:block" />

                    <div className="relative overflow-hidden rounded-[32px] border border-white/70 bg-white shadow-[0_30px_90px_rgba(16,38,26,0.18)]">
                        <div className="relative min-h-[420px] sm:min-h-[520px] lg:min-h-[720px]">
                            <img
    src="/images/Hiru/public_images/680A4135-Enhanced-NR-Edit-copy.webp"
    alt="Ayurveda-Bereich des Hiru Resorts"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/70 via-[#07130d]/20 to-transparent" />
                        </div>

                        <div className="absolute inset-x-4 bottom-4 grid grid-cols-1 gap-3 sm:inset-x-6 sm:grid-cols-2">
                            <div className="rounded-2xl border border-white/20 bg-white/15 p-4 text-white shadow-lg backdrop-blur-md">
                                <p className="font-mulish text-xs uppercase tracking-[0.14em] text-white/75">Aufenthalt</p>
                                <p className="mt-2 font-serif text-2xl font-semibold">14 Tage oder mehr</p>
                                <p className="mt-1 font-mulish text-sm text-white/85">Empfohlene Mindestdauer für spürbare Ergebnisse</p>
                            </div>
                            <div className="rounded-2xl border border-white/20 bg-white/15 p-4 text-white shadow-lg backdrop-blur-md">
                                <p className="font-mulish text-xs uppercase tracking-[0.14em] text-white/75">Support</p>
                                <p className="mt-2 font-serif text-2xl font-semibold">Mehrsprachig</p>
                                <p className="mt-1 font-mulish text-sm text-white/85">Unterstützung auf mehreren Sprachen, inklusive Japanisch</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default AboutAyurveda;
